/** Pré-perguntas usuais — Diário técnico (go_app_log / diretriz). */

export const DIARIO_ORYA_QUICK_PROMPTS = [
  {
    id: 'resumo',
    icon: 'calendar',
    label: 'Resuma o dia deste técnico',
  },
  {
    id: 'erros',
    icon: 'sparkle',
    label: 'Teve algum erro ou envio que não chegou?',
  },
  {
    id: 'offline',
    icon: 'bolt',
    label: 'Quais ações foram feitas sem rede?',
  },
  {
    id: 'buraco',
    icon: 'calendar',
    label: 'Houve períodos sem sincronização?',
  },
  {
    id: 'versao',
    icon: 'sparkle',
    label: 'Qual versão do app estava em uso?',
  },
];
